import { UserRole } from './user-role';
import { UserPermission } from './user-permission';

export const UserRolePermission: {
  [key: string]: Array<string>;
} = {};

UserRolePermission[UserRole.SystemAdmin] = [UserPermission.ViewHome, UserPermission.EditHome];
UserRolePermission[UserRole.Guest] = [UserPermission.ViewHome];
